export const OPTIONAL_SERVICES_COST_PER_PAGE = 0.25